module.exports = __webpack_public_path__ + "static/media/apple.ed9cb16c.svg";